import React from 'react'
import { Row, Col, Image, Form } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import Select from 'react-select'
import userDefault from '../../img/userdefault.png'
import iconCalendar from '../../img/icons/calendar.svg'
import moment from 'moment'

function PerfilDoctorMin({t, doctorInfo, speciality, doctoresOptDef, onHandleChangeDoctor, schedule, doctor, scheduleDTO}){
    return(
        <>
            <Row>
                <Col xs="6" sm="6" md="6" lg="6" xl="4">
                    <Image src={doctorInfo?.url_photo !== '' ? doctorInfo?.url_photo : userDefault} roundedCircle className='doctor-foto doctor-foto-sm' />
                </Col>
                <Col xs="6" sm="6" md="6" lg="6" xl="8" className='doctor-name-container'>
                    <span className='doctor-nombre'>
                        {`${doctorInfo?.name} ${doctorInfo?.lastName}`}<br/>
                    </span>
                    <small className="d-block font-size-09rem">{ speciality.name }</small>
                    <strong>{moment(scheduleDTO?.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD MMM YYYY HH:mm")}</strong>
                </Col>
            </Row>
            <Row className="my-3">
                <Col>                    
                    <h6 className="title-top-2">Asignar nuevo médico</h6>
                    <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">{t('doctor')}</Form.Label>
                        <Select 
                            className="input-appointment"
                            value={doctor}
                            options={doctoresOptDef}
                            onChange={(value) => onHandleChangeDoctor(value)}
                        />
                        {/* {!schedule && <small className="text-warning d-block m-0">Por favor seleccionar horario</small>} */}
                    </Form.Group>
                </Col>
            </Row>
            {schedule && 
            <Row>
                <Col xs="12" md="12">
                    <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">{t('hora_asignada')}</Form.Label>
                        <div className="div-form-control">
                            <Image fluid src={iconCalendar} className="mr-4 mb-1 h-20" /> {moment(schedule.hourInit, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")} 
                        </div>
                    </Form.Group>
                </Col>
            </Row>}
        </>
    )
}

export default withTranslation()(PerfilDoctorMin)